import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";

export default function ChatOrderInfo({ orderId }) {
  const { t } = useI18n();
  const [o, setO] = useState(null);
  useEffect(() => {
    setO(null);
    if (orderId) { api.get(`/orders/${orderId}`).then((r) => setO(r.data)).catch(() => {}); }
  }, [orderId]);
  if (!o) return null;
  return (
    <Link to={`/orders/${o.id}`} data-testid="chat-order-info"
      className="flex items-center gap-3 px-4 py-2 border-b border-[#35353B] bg-[#D4AF37]/5 hover:bg-[#D4AF37]/10 transition-colors text-sm">
      <Package size={16} className="text-[#D4AF37] shrink-0" />
      <span className="hidden sm:inline text-xs uppercase tracking-widest text-[#A8A8AD]">{t("order.no")}</span>
      <span data-testid="chat-order-no" className="font-mono text-[#D4AF37] whitespace-nowrap truncate">{o.order_no}</span>
      <span data-testid="chat-order-status" className="ml-auto shrink-0 px-2 py-0.5 border border-[#D4AF37] text-[#D4AF37] rounded-sm text-xs">{t(`order.status.${o.status}`)}</span>
    </Link>
  );
}
